import { render, staticRenderFns } from "./pInviteForm.vue?vue&type=template&id=6965ea06&scoped=true"
import script from "./pInviteForm.vue?vue&type=script&lang=js"
export * from "./pInviteForm.vue?vue&type=script&lang=js"
import style0 from "./pInviteForm.vue?vue&type=style&index=0&id=6965ea06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6965ea06",
  null
  
)

export default component.exports